import { Box } from '@unity/cloud-ui';
import z from 'zod';
import { getComponentDocumentationUrl } from '@/utils/get-component-doc-url';
import { Accordion, AccordionGroup } from '../accordion';

export const Expandable = (props: z.input<typeof expandableSchema>) => {
  return (
    <Box>
      <AccordionGroup>
        <Accordion title={props.title}>{props.children}</Accordion>
      </AccordionGroup>
    </Box>
  );
};

const documentationUrl = getComponentDocumentationUrl('expandables');

const descriptions = {
  title: 'The title of the expandable. It is displayed in the open and closed state.',
  children: 'The content of the expandable.',
  schema: `Help group your content together.\n\\n**Example**\n\`\`\`mdx\n<Expandable title="User Information">\n  The name of the user\n</Expandable>\n\`\`\`\n\n${documentationUrl}`,
};

export const expandableSchema = z
  .object({
    title: z.string().describe(descriptions.title),
    children: z.any().describe(descriptions.children),
  })
  .describe(descriptions.schema);
